// Copyright (c) Microsoft. All rights reserved.

import { Body1, makeStyles, Subtitle1, Title3 } from '@fluentui/react-components';
import { FC } from 'react';
import { useClasses } from '../../App';

const useMissingEnvVariablesErrorClasses = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '80px',
        gap: '20px',
    },
});

interface IData {
    missingVariables: string[];
}

const MissingEnvVariablesError: FC<IData> = ({ missingVariables }) => {
    const classes = useClasses();
    const missingEnvVariablesErrorClasses = useMissingEnvVariablesErrorClasses();

    return (
        <div className={classes.container}>
            <div className={classes.header}>
                <Subtitle1 as="h1">Copilot Chat</Subtitle1>
            </div>
            <div className={missingEnvVariablesErrorClasses.container}>
                <Title3>
                    {
                        'Please ensure your ".env" file is set up correctly with all environment variables defined in ".env.example" then restart the app.'
                    }
                </Title3>
                <Body1>You are missing the following variables: {missingVariables.join(', ')}</Body1>
            </div>
        </div>
    );
};

export default MissingEnvVariablesError;
